import { VendorIndividualPaymentSubmitData } from "../models/VendorRequestChange/VendorRequestChangeData";
import { AxiosConfig } from "./AxiosConfig";

const submitVendorIndividualPayment = async (
  vendorIndividualPaymentSubmitData: VendorIndividualPaymentSubmitData,
    successCallback: (vendorIndividualPaymentData: any) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.post("/VendorIndividualPayment/SaveIndividualVendor", vendorIndividualPaymentSubmitData);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

export const VendorIndividualPaymentService = {
  submitVendorIndividualPayment
  };